import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getStatus = async (bsd_id) => {
  const requestBody = { bsd_id };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getSttusStd`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getChartData = async (startDt, endDt, list) => {
  const requestBody = {
    startDt,
    endDt,
    list,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getChartData`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

/*
export const getChart = async (startDt, list) => {
  const requestBody = {
    startDt,
    list,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getChartSttus`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
*/
